<template>
  <div v-loading="loadingPrincipal" class="sectionContainer">
    <div v-if="!loadingPrincipal">
      <Title title="Seguimiento Empresa"
             subtitle="Sigue el progreso de las rutas activas y finalizadas"/>
      <div>
        <el-tabs type="card" class="content fullTab">
          <el-tab-pane label="Rutas">
            <div>
              <div class="top">
                <el-row class="search-box greenAppend">
                  <el-col :span="5">
                  <TracingSearchEnterprise
                    ref="searchBox"
                    :valueInput="variable"
                    :toSearch="clickOnClientValue"
                    @data="infoData"
                    @loaderSearch="updateLoader"
                    @notFound="setNotFound"
                    @type="infoType"
                    @active="showHide"
                    @restart="homeView" />
                  </el-col>
                </el-row>
              </div>
              <div v-if="searchActive === 0">
                <div v-if="!show404">
                  <el-row :gutter="30" v-loading="loading">
                    <el-col :span="5">
                      <div v-if="loadingTree">
                        <p style="font-size: 14px; color: #A0BE03">
                          <i class="el-icon-loading" style="margin-right: 5px;"></i>CARGANDO RUTAS
                        </p>
                      </div>
                      <p></p>
                      <el-input
                        placeholder="Ingresa patente o ruta"
                        prefix-icon="el-icon-search"
                        size="mini"
                        v-model="filterTextThree">
                      </el-input>
                      <div class="tree" v-show="!loadingTree">
                        <div class="checkAll">
                          <el-checkbox
                            style="font-size: 18px; margin-top: 10px;"
                            disabled
                            @change="selectedAll">TODAS
                          </el-checkbox>
                        </div>
                        <el-tree
                          style="margin-right: 20px;"
                          ref="entrerpriceTree"
                          :data="dataTree"
                          empty-text="SIN DATA"
                          :filter-node-method="filterNode"
                          :render-after-expand="render"
                          node-key="id"
                          show-checkbox
                          @check-change="handleCheckChange"
                          :props="defaultProps">
                        </el-tree>
                      </div>
                    </el-col>
                    <el-col :span="18">
                      <tracing-routes-table-v2
                        style="height: 500px;"
                        ref="tableRoutesActives"
                        @clickSoc="socDetails"
                        @loadTree = "finishLoadTable"
                        :routes="selectedRoutesSocActives">
                      </tracing-routes-table-v2>
                    </el-col>
                  </el-row>
                </div>
                <div v-else class="emptyStyle">
                  <NotFound
                    imgName="fb-map.svg"
                    textGreen="No se encontraron"
                    textGrey="rutas para hoy" />
                </div>
              </div>
              <div v-else>
                <TracingClient
                  class="paddingContainer paddingTop"
                  v-loading="loadingState"
                  v-if="typeSearch === 2"
                  @restart="homeView"
                  @clickOnClient="sendClientData"
                  @clickSearchLupa="cleanData"
                  :dataClient="dataSearchClient"
                  :routes="routes"
                  :notFound="displayNotFound"
                />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Administración Conductores">
            <TracingEnterpriseDrivers/>
          </el-tab-pane>
          <el-tab-pane label="Administración Vehículos">
            <TracingEnterpriseVehicles/>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import { tenantTimeZone } from '@/mixins/tenants';
import { apiRequest } from '../../backend/vue-axios/axios';
import Title from '../components/base/Title.vue';
import TracingSearchEnterprise from '../components/TracingSearchEnterprise.vue';
import NotFound from '../components/Base404.vue';
import TracingClient from '../components/TracingClient.vue';
import TracingEnterpriseVehicles from '../components/TracingEnterpriseVehicles.vue';
import TracingRoutesTableV2 from '../components/TracingRoutesTableV2.vue';
import TracingEnterpriseDrivers from '../components/TracingEnterpriseDrivers.vue';

export default {
  props: {
    windowWidth: {
      type: Number,
    },
  },
  name: 'TracingEnterpriseV1',
  components: {
    TracingRoutesTableV2,
    TracingEnterpriseVehicles,
    TracingEnterpriseDrivers,
    TracingClient,
    TracingSearchEnterprise,
    Title,
    NotFound,
  },
  data() {
    return {
      loadingTree: false,
      loadingPrincipal: false,
      show404: false,
      loading: false,
      loadComponents: false,
      moduleLoadingOne: true,
      chartDisplayType: '',
      displayNotFound: false,
      searchActive: 0,
      variable: 0,
      typeSearch: 0,
      dataSearchDriver: {},
      dataSearchClient: {},
      dataDriverforClient: {},
      input: {},
      routes: [],
      typeResult: 0,
      loadingState: true,
      searchedInfo: {},
      clickOnClientValue: '',
      selectedId: '',
      selectedEnterprise: 'General',
      selectedResult: [],
      data: {
        enterprises: [],
      },
      dataTree: [],
      defaultProps: {
        children: 'active_routes',
        label: 'name',
      },
      dataEnterprisesActiveRoutesEnt: [],
      dataRoutesActive: [],
      selectedRoutesActives: [],
      selectedRoutesSocActives: [],
      showTable: true,
      render: false,
      filterText: '',
      adminTab: 'top',
      allRouteData: [],
      allEnterpriceData: [],
      filterTextThree: '',
      timeZone: '',
    };
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    setNotFound(data) {
      this.displayNotFound = data;
    },
    finishLoadTable() {
      this.loadingTree = false;
    },
    showHide(active) {
      this.searchActive = active;
    },
    getEnterprisesList() {
      apiRequest({
        module: 'planning',
        service: 'enterprises',
        params: {
          limit: 6000,
        },
      }).then((data) => {
        this.data.enterprises = data.data;
      }).catch(() => {
        /* this.$notify.error({
          title: 'Error',
          message: 'Error al cargar empresas',
        }); */
      });
    },
    sendClientData(data) {
      // this.$router.push({ name: 'Tracing', query: { v: data.vehicle.patent } });
      this.clickOnClientValue = data.toString();
    },
    getEnterprises() {
      const init = new Date();
      const initTime = moment(init).format('YYYY-MM-DD');
      const finish = init.setDate(init.getDate() + 1);
      const finishTime = moment(finish).format('YYYY-MM-DD');
      apiRequest({
        module: 'tracing',
        service: 'enterprises',
        params: {
          time_init: initTime,
          time_end: finishTime,
        },
      }).then((result) => {
        this.chartDataInfo.length = 0;
        this.chartDataInfo.push(result.data);
      }).catch(() => {
        /* this.$notify.error({
          title: 'Error',
          message: 'Error al cargar empresas',
        }); */
      });
    },
    getRouteClientView(vehicle) {
      apiRequest(vehicle).then((res) => {
        this.dataDriverforClient = res.data;
        this.routes = [this.dataDriverforClient];
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar información',
        });
      });
    },
    infoData(data) {
      this.searchedInfo = data;
      if (this.typeSearch === 2) {
        this.dataSearchClient = this.searchedInfo;
        this.$router.push({ name: 'TracingEnterpriseV1', query: { v: data.suborder.code } });
      }
      this.loadingState = false;
    },
    updateLoader(data) {
      this.loadingState = data;
    },
    infoType(type) {
      this.typeSearch = type;
    },
    homeView(restart) {
      this.searchActive = restart;
      this.variable = this.variable + 1;
    },
    // tree
    getRoutesActive() {
      if (sessionStorage.active_routes !== undefined) {
        this.dataRoutesActive = JSON.parse(sessionStorage.active_routes);
      } else {
        apiRequest({
          module: 'tracing',
          service: 'get_active_routes',
        }).then((data) => {
          this.dataRoutesActive = data.data;
          sessionStorage.active_sroutes = JSON.stringify(this.dataRoutesActive);
        }).catch(() => {
          this.$notify.error({
            title: 'Error',
            message: 'Error al obtener rutas del día. Tree',
          });
        });
      }
    },
    enterprisesActiveRoutes(typeUpdate) {
      this.loadingPrincipal = true;
      if (sessionStorage.dataEnterprisesActiveRoutesEnt !== undefined) {
        // eslint-disable-next-line
        this.dataEnterprisesActiveRoutesEnt = JSON.parse(sessionStorage.dataEnterprisesActiveRoutesEnt);
        if (typeUpdate === 'update') {
          this.updateDataRoutes();
        } else {
          this.formatDataRoutes();
        }
        this.loadingPrincipal = false;
      } else {
        apiRequest({
          module: 'tracing',
          service: 'enterprises_active_routes',
        }).then((data) => {
          this.dataEnterprisesActiveRoutesEnt = data.data;
          // eslint-disable-next-line
          sessionStorage.dataEnterprisesActiveRoutesEnt = JSON.stringify(data.data);
          if (typeUpdate === 'update') {
            this.updateDataRoutes();
          } else {
            this.formatDataRoutes();
          }
          this.loadingPrincipal = false;
        }).catch((err) => {
          if (err.response.status === 404) {
            this.show404 = true;
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Error al obtener información de rutas del día',
            });
          }
          this.loadingPrincipal = false;
        });
      }
    },
    updateDataRoutes() {
      const newDataTree = [];
      this.dataEnterprisesActiveRoutesEnt.forEach((e) => {
        const child = [];
        e.active_routes.forEach((a) => {
          const dataTreeResult = this.dataTree.find(dt => dt.id === a.id);
          let selectedChild = false;
          if (dataTreeResult) {
            selectedChild = dataTreeResult[0].selected;
          }
          const ruta = {
            empId: e.id,
            id: a.id,
            name: a.patent,
            type: 'vehicle',
            selected: selectedChild,
          };
          child.push(ruta);
        });
        const dataTreeResultEmp = this.dataTree.find(dt => dt.id === e.id);
        let selectedEmp = false;
        if (dataTreeResultEmp) {
          selectedEmp = dataTreeResultEmp[0].selected;
        }
        const reparto = {
          id: e.id,
          name: e.name,
          type: 'enterprise',
          selected: selectedEmp,
          active_routes: child,
        };
        newDataTree.push(reparto);
      });
      this.dataTree = newDataTree;
    },
    formatDataRoutes() {
      this.dataTree = [];
      if (this.dataEnterprisesActiveRoutesEnt) {
        this.dataEnterprisesActiveRoutesEnt.forEach((e) => {
          const child = [];
          e.active_routes.forEach((a) => {
            const ruta = {
              empId: e.id,
              id: a.id,
              name: `${a.patent} | ${a.id}`,
              type: 'vehicle',
              selected: false,
            };
            child.push(ruta);
          });
          const reparto = {
            id: e.id,
            name: e.name.replace('TRANSPORTE' || 'TRANSPORTES', 'T.'),
            type: 'enterprise',
            selected: false,
            active_routes: child,
            isWorking: false,
            itemCount: 0,
            disabled: false,
          };
          this.dataTree.push(reparto);
        });
      }
    },
    handleCheckChange(dataIn, checked) {
      // eslint-disable-next-line
      dataIn.selected = checked;
      if (dataIn && dataIn.type === 'vehicle') {
        const node = this.$refs.entrerpriceTree.getNode(dataIn.empId);
        if (!node.data.isWorking) {
          const routeId = parseInt(dataIn.id, 10);
          if (dataIn.selected) {
            this.getRouteId(routeId).then(() => {
            }).finally(() => {
              node.data.isWorking = false;
            });
          } else {
            this.selectedRoutesActives = this.selectedRoutesActives.filter(r => r.id !== routeId);
            this.removeSocTable(routeId);
          }
        } else {
          node.data.itemCount -= 1;
          if (node.data.itemCount < 1 && dataIn.selected === false) {
            node.data.isWorking = false;
          }
        }
      } else if (dataIn && dataIn.type === 'enterprise') {
        // const routeId = parseInt(dataIn.id, 10);
        const node = this.$refs.entrerpriceTree.getNode(dataIn.id);
        if (dataIn.selected) {
          node.data.isWorking = true;
          const routesId = dataIn.active_routes.map(r => r.id);
          this.getRoutes(dataIn.id, routesId).finally(() => {
            node.data.isWorking = false;
          });
        } else {
          // eslint-disable-next-line
          const countRoutesSelected = this.$refs.entrerpriceTree.getCheckedNodes().filter(cn => cn.empId === dataIn.id).length;
          if (countRoutesSelected === 0) {
            node.data.isWorking = true;
            // eslint-disable-next-line
            const countRoutes = this.selectedRoutesActives.filter(r => r.enterprisesid === dataIn.id).length;
            node.data.itemCount = countRoutes;
            // eslint-disable-next-line
            // eslint-disable-next-line
            this.selectedRoutesActives = this.selectedRoutesActives.filter(r => r.enterprisesid !== dataIn.id);
            // eslint-disable-next-line
            this.selectedRoutesSocActives = this.selectedRoutesSocActives.filter(r => r.enterpriseId !== dataIn.id);
            // node.data.isWorking = false;
          }
        }
      }
    },
    getRouteId(elementId) { // Llamado de a 1 ruta
      return new Promise((resolve, reject) => {
        const route = this.allRouteData.find(e => e.id === elementId);
        if (!route) {
          this.$message({
            title: 'Loading...',
            message: `Cargando información de ruta id ${elementId}`,
            duration: 8000,
            showClose: true,
          });
          apiRequest({
            module: 'tracing',
            service: 'enterprises_active_one',
            pathparam: { id: elementId },
          }).then((data) => {
            // eslint-disable-next-line
            this.allRouteData.push(data.data.routes[0]);
            // this.selectedRoutesActives.push(data.data.routes[0]);
            this.addSocTable(data.data.routes[0]);
            sessionStorage.active_route_enterprises_ent = JSON.stringify(this.allRouteData);
            this.loadingPrincipal = false;
            resolve(true);
          }).catch((err) => {
            if (err.response.status === 404) {
              this.show404 = true;
            } else {
              this.$notify.error({
                title: 'Error',
                message: 'Error al obtener información de rutas',
              });
            }
            this.loadingPrincipal = false;
            reject(err);
          });
        } else {
          this.selectedRoutesActives.push(route);
          this.addSocTable(route);
          resolve(true);
        }
      });
    },
    getRoutes(enterpriseId, routesId) { // enterpriseId = OLD -> elementId
      return new Promise((resolve, reject) => {
        const enterpriceSelected = this.allEnterpriceData.find(e => e === enterpriseId);
        if (enterpriceSelected !== undefined) {
          const route = this.allRouteData.filter(r => r.enterprisesid === enterpriseId);
          if (route) {
            route.forEach((empRoute) => {
              const tableDataRoute = this.selectedRoutesActives.find(r => r.id === empRoute.id);
              if (!tableDataRoute) {
                this.selectedRoutesActives.push(empRoute);
                this.addSocTable(empRoute);
              }
            });
          }
          resolve(true);
        } else {
          this.$message({
            title: 'Loading...',
            message: 'Cargando información del transporte',
            duration: 8000,
            showClose: true,
          });
          apiRequest({
            module: 'tracing',
            service: 'enterprises_tracking',
            params: { ids: routesId },
          }).then((data) => {
            // eslint-disable-next-line
            data.data.routes.forEach((e) => {
              const route = this.allRouteData.find(r => r.id === e.id);
              if (route !== undefined) {
                const tableDataRoute = this.selectedRoutesActives.find(r => r.id === route.id);
                if (!tableDataRoute) {
                  this.selectedRoutesActives.push(route);
                  this.addSocTable(route);
                }
              } else {
                this.allRouteData.push(e);
                this.selectedRoutesActives.push(e);
                this.addSocTable(e);
              }
            });
            sessionStorage.active_route_enterprises_ent = JSON.stringify(this.allRouteData);
            // this.setDataTable();
            this.allEnterpriceData.push(enterpriseId);
            sessionStorage.active_enterprises_ent = JSON.stringify(this.allEnterpriceData);
            resolve(true);
          }).catch((err) => {
            if (err.response.status === 404) {
              this.show404 = true;
            } else {
              this.$notify.error({
                title: 'Error',
                message: 'Error al obtener información de rutas',
              });
            }
            reject(err);
          });
        }
      });
    },
    selectedAll(val) {
      // this.loadingTree = true;
      if (this.dataTree !== undefined) {
        this.dataTree.forEach((e) => {
          this.$refs.entrerpriceTree.setChecked(e.id, val, 3);
        });
      }
      this.loadingTree = false;
    },
    addSocTable(route) {
      const findingRoute = this.selectedRoutesSocActives.find(r => r.routeId === route.id);
      if (!findingRoute && route) {
        // console.time('add_soc_to_table');
        route.socs.forEach((s) => {
          const dataRowSoc = {
            patent: s.patent,
            enterpriseId: route.enterprisesid,
            routeId: s.routeId,
            soc: s.soc,
            commune: s.commune,
            locality: s.locality,
            position: s.position + 1,
            winInit: moment.utc(s.winInit).format('HH:mm'),
            winFinish: moment.utc(s.winFinish).format('HH:mm'),
            eta: (s.position === null) ? 'L.E' : moment(s.eta).tz(this.timeZone).format('HH:mm'),
            // eta: (s.position === null) ? 'L.E' : moment.utc(s.eta).format('HH:mm'),
            // real:
            // eslint-disable-next-line
            // (s.real === '0001-01-01T00:00:00Z') ? '--- : ---' : moment.utc(s.real).format('HH:mm'),
            real:
            // eslint-disable-next-line
            (s.real === '0001-01-01T00:00:00Z') ? '--- : ---' : moment(s.real).tz(this.timeZone).format('HH:mm'),
            customerName: s.customerName,
            status: s.status,
            isValid: route.id === s.routeId,
          };
          this.selectedRoutesSocActives.push(dataRowSoc);
        });
        // console.timeEnd('add_soc_to_table');
      }
    },
    removeSocTable(routeId) {
      // eslint-disable-next-line
      this.selectedRoutesSocActives = this.selectedRoutesSocActives.filter(r => r.routeId !== routeId);
      // console.timeEnd('removeSocTable');
    },
    socDetails(soc) {
      this.selectedRoutesActives = [];
      this.$refs.searchBox.input = soc;
      this.$refs.searchBox.submit();
    },
    cleanData() {
      this.selectedRoutesActives = [];
    },
  },
  created() {
    this.$options.interval = setInterval(() => {
      sessionStorage.removeItem('active_route_enterprises_ent');
      sessionStorage.removeItem('dataEnterprisesActiveRoutesEnt');
      sessionStorage.removeItem('active_enterprises_ent');
      this.selectedRoutesActives = [];
      this.allEnterpriceData = [];
      this.selectedRoutesSocActives = [];
      if (this.dataTree !== undefined) {
        this.dataTree.forEach((e) => {
          this.$refs.entrerpriceTree.setChecked(e.id, false, 3);
        });
      }
    }, 300000);
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
  mounted() {
    this.timeZone = tenantTimeZone();
    if (sessionStorage.active_route_enterprises_ent !== undefined) {
      this.allRouteData = JSON.parse(sessionStorage.active_route_enterprises_ent);
    }
    if (sessionStorage.active_enterprises_ent !== undefined) {
      this.allEnterpriceData = JSON.parse(sessionStorage.active_enterprises_ent);
    }
    this.enterprisesActiveRoutes('new');
  },
  watch: {
    filterTextThree(val) {
      const valor = val.toUpperCase();
      this.$refs.entrerpriceTree.filter(valor);
    },
    selectedResult(newEl) {
      if (newEl[0].progress.total > 0) {
        this.loadEmpty = false;
      } else {
        this.loadEmpty = true;
      }
    },
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
    },
  },
};
</script>

<style lang="scss" scoped>
  .checkAll {
    text-align: left;
  }
  .enterpriseFilter {
    min-width: 200px;
    margin-left: 20px;
  }
  .fullTab {
  }
  .home-view {
    width: 100%;
    height: 100%;
  }
  .content {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-bottom: 2em;
  }
  .top {
    display: flex;
    justify-content: space-evenly;
  }
  .search-box {
    width: 100%;
  }
  .paddingContainer {
    margin: 0 !important;
  }
  .paddingTop {
    padding-top: 1.5em;
  }
  .gutterStart {
    padding-right: 10px;
  }
  .gutterEnd {
    padding-left: 10px;
  }
  .fb-map {
    width: 320px;
  }

  .sectionContainer.wrap {
    overflow: scroll !important;
  }

  .titleStyle {
    font-size: 2em;
    font-weight: 900;
    text-transform: uppercase;
    margin: 0;
  }
  .green {
    color: $fb-green;
  }
  .grey {
    color: $fb-grey-light-50;
  }
  .emptyStyle {
    margin-top: 2em;
  }
  .tracingChart {
    z-index: 90;
  }
  @media only screen and (max-width: 1010px) and (min-width: 768px) {
    .ns {
      min-width: 55%;
    }
  }
  @media only screen and (max-width: 768px) {
    .sectionContainer {
      width: 100vw;
      position: relative;
    }
    .paddingTopSm {
      padding-top: 1em;
    }
    .paddingTop {
      padding-top: 1em;
    }
    .gutterStart {
      padding-right: 0;
    }
    .gutterEnd {
      padding-left: 0;
    }
    .titleStyle {
      font-size: 1.5em;
    }
  }
  @media only screen and (max-width: 767px) {
    .top {
      flex-direction: column;
    }
    .enterpriseFilter{
      margin-left: 0;
      margin-top: 0.5em;
    }
    .ns {
      justify-content: center;
      margin-top: 0.5em;
      background: $fb-grey-light-94;
      padding: 1em;
    }
  }
</style>
